import React, { Component } from "react";

import { Router, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import { Provider } from "react-redux";
import store from "./store";
import { setInfo } from "./actions/settingActions";

import "./App.css";

import DocumentTitle from "react-document-title";

import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";

import Home from "./components/Home";
import FurtherInformation from "./components/FurtherInformation";
import Media from "./components/Media";
import Prompt from "./components/Prompt";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#00568E",
    },
  },
});

const customHistory = createBrowserHistory();

class App extends Component {
  componentDidMount() {
    var location = customHistory.location;
    if (location.hash === "#info") {
      setInfo(true, "");
    } else if (location.hash === "#hilfestellungen") {
      setInfo(true, "hilfestellungen");
    } else if (location.hash === "#links") {
      setInfo(true, "links");
    } else if (location.hash === "#impressum") {
      setInfo(true, "impressum");
    } else if (location.hash === "#bibliotheken") {
      setInfo(true, "bibliotheken");
    }
    var pathname = location.pathname;
    if (pathname[pathname.length - 1] === "/") {
      pathname = pathname.slice(0, pathname.length - 1);
    }
    customHistory.replace(pathname);
  }

  render() {
    const customHistory = createBrowserHistory();
    return (
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <Router history={customHistory}>
            <Prompt history={customHistory} />
            <Route exact path={"/muehlenkataster/medien"}>
              <Media />
            </Route>
            <Route exact path={"/muehlenkataster/:gemeinde/:objektnr"}>
              <FurtherInformation />
            </Route>
            <Route>
              <DocumentTitle title="Mühlen im Kreis Herford">
                <Home />
              </DocumentTitle>
            </Route>
          </Router>
        </Provider>
      </ThemeProvider>
    );
  }
}

export default App;
